import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchUnAssignTeachers } from "../../features/SchoolModule/teachers/redux/teacherSlice";
import { getMasterDataByUserId } from "../masterData/redux/masterDataThunk";
import { updateTeacherUser, fetchOrgUsersById } from "./redux/userThunk";
import userStore from "../../zustand/userStore";

const AssignTeacher = ({ userId, onClose }) => {
  const dispatch = useDispatch();
  const userData = userStore((state) => state.user);
  const { allteachers: teachers } = useSelector((state) => state.teachers);
  const { school_id } = useSelector((state) => state.masterData || {});

  const [selectedTeacherId, setSelectedTeacherId] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userData?.id) {
      dispatch(getMasterDataByUserId(userData.id));
    }
  }, [dispatch, userData?.id]);

  useEffect(() => {
    if (school_id) {
      dispatch(fetchUnAssignTeachers());
    }
  }, [dispatch, school_id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedTeacherId) {
      alert("Please select a teacher");
      return;
    }

    setLoading(true);
    try {
      await dispatch(
        updateTeacherUser({
          user_id: userId,
          teacher_id: Number(selectedTeacherId),
        })
      ).unwrap();

      alert("Teacher assigned successfully!");
      dispatch(fetchOrgUsersById(userData?.id));
      if (onClose) onClose();
    } catch (err) {
      alert(err || "Failed to assign teacher");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "16px" }}>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "16px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "8px",
              fontWeight: 500,
              fontSize: "14px",
            }}
          >
            Select Teacher
          </label>
          <select
            className="form-select"
            value={selectedTeacherId}
            onChange={(e) => setSelectedTeacherId(e.target.value)}
            required
            style={{ width: "100%", height: "38px" }}
            disabled={loading}
          >
            <option value="">Select a teacher</option>
            {teachers?.length ? (
              teachers.map((t) => (
                <option key={t.teacher_id} value={t.teacher_id}>
                  {t.name}
                </option>
              ))
            ) : (
              <option disabled>No teachers found</option>
            )}
          </select>
        </div>

        <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end", marginTop: "20px" }}>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
            style={{ padding: "6px 16px", borderRadius: "5px" }}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            style={{ padding: "6px 16px", borderRadius: "5px" }}
            disabled={loading}
          >
            {loading ? "Assigning..." : "Assign"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AssignTeacher;
